import { requestBuilder } from '../../http/RequestBuilder';

export interface PaymentMethodSummary {
    id: string;
    brand: string;
    last4: string;
    addedByName: string | null;
}

export const formatCardBrand = (brand: string): string =>
    brand.charAt(0).toUpperCase() + brand.slice(1);

export const formatPaymentMethodLabel = (
    paymentMethod: Pick<PaymentMethodSummary, 'brand' | 'last4'>,
): string => `${formatCardBrand(paymentMethod.brand)} *${paymentMethod.last4}`;

export const useGetPaymentMethod = requestBuilder.query<
    PaymentMethodSummary | null,
    { userId: string }
>({
    endpoint: () => '/api/billing/payment-method',
    queryKey: ({ userId }) => `getPaymentMethod/${userId}`,
});

type CreatePaymentMethodSetupIntentBody = Record<string, never>;

export const useCreatePaymentMethodSetupIntent = requestBuilder.mutation<
    { clientSecret: string; setupIntentId: string },
    CreatePaymentMethodSetupIntentBody
>({
    endpoint: '/api/billing/payment-method/setup-intent',
    method: 'POST',
});

/** Send exactly one of `paymentMethodId` (card form) or `setupIntentId` (PaymentSheet). */
export const useAttachPaymentMethod = requestBuilder.mutation<
    PaymentMethodSummary | null,
    { paymentMethodId?: string; setupIntentId?: string }
>({
    endpoint: '/api/billing/payment-method',
    method: 'POST',
});

type RemovePaymentMethodBody = Record<string, never>;

export const useRemovePaymentMethod = requestBuilder.mutation<
    { success: boolean },
    RemovePaymentMethodBody
>({
    endpoint: '/api/billing/payment-method',
    method: 'DELETE',
});
